import { Dialog, DialogContent, DialogTitle, Typography } from "@material-ui/core";
import React, { useEffect, useReducer, useState } from "react";
import translate from "../../../i18n/translate";
import Loader from "../../shared/Loader/Loader";
import Toaster from "../../shared/Toaster/Toaster";
import MyScheduleSummaryBlock from "./MyScheduleSummaryBlock";
import "./MyScheduleSummaryBlock.scss";
import NoTrainerScenarioBlock from "./NoTrainerScenarioBlock";
import PastAndUpcomingSessions from "./PastAndUpcomingSessions";
import CloseIcon from "@material-ui/icons/Close";
import { useSelector, useDispatch } from "react-redux";  
import allActions from "../../../redux/actions";
import { useLocation } from "react-router-dom";
  import { getActiveCourse } from "./MySchedulePageUtils";
const ProductSessionsBlock: React.FC = () => {
  const allInfo = useSelector((state: any) => state);
  const dispatch = useDispatch();
  const [validatedCourseId, setValidatedCourseId] = useState(0);
  const[isTMSloginComplete, setIsTMSLoginComplete]= useState(true);
  const [triggerDispatch, setTriggerDispatch]= useState(false);
  const [feedbackHit, setFeedbackHit] = useState(false);

  const callTMSLogout = async () => {
    if(!allInfo.tmsCourses.isLoginSucceeded || !allInfo.tmsCourses.isLogoutSucceeded){
      dispatch(allActions.tmsCoursesAction.callTMSLogOut());
    } else {
      if(allInfo.learnerJWToken && allInfo.learnerJWToken.data && allInfo.learnerJWToken.data.getLearnerJwtoken){
        callTMSLogin(allInfo.learnerJWToken.data.getLearnerJwtoken);
      }
    }
    sessionStorage.setItem("JwToken",allInfo.learnerJWToken.data.getLearnerJwtoken);
  };
  
  const callTMSLogin = async (learnerToken: string) => {
    if(!allInfo.tmsCourses.isLoginSucceeded || !allInfo.tmsCourses.isLogoutSucceeded){
      dispatch(allActions.tmsCoursesAction.callTMSLogin(learnerToken));
    } 
  };

  const getLearnerToken = async (edgeUid: string, username: string) => {
    const geId = allInfo.common.lgId;
    const uuId = allInfo.common.luuId;
    const iss = "ge_coach";
    if(!allInfo.learnerJWToken.data) {
      dispatch(allActions.learnerJWTokenAction.getLearnerJWToken(geId, edgeUid, username, uuId, iss));
    } else {      
      sessionStorage.setItem("JwToken",allInfo.learnerJWToken.data.getLearnerToken);
      callTMSLogout();
    }
  };

  // document.title = "Halo - Schedule"
  let [status, setstatus] = useState(0);
  
  const [toastOptions, settoastOptions] = useReducer((state: any, newState: any) => ({ ...state, ...newState }), {
    toastOpen: false,
    toastSeverity: "error",
    toastMessageKey: "",
  });

  const handleToastOptionsDirect = (name: string, val: any) => {
    settoastOptions({ [name]: val });
  }

  const toasterHandle = (open: boolean, severity: string, messageKey: string) => {
    handleToastOptionsDirect("toastSeverity", severity);
    handleToastOptionsDirect("toastMessageKey", messageKey);
    handleToastOptionsDirect("toastOpen", open);
  };

  const getLearnerInfo = async () => {
    if(allInfo.peopleInformation.isLoading && !allInfo.peopleInformation.data){
      dispatch(allActions.peopleInformationActions.getStorePeopleInfo(allInfo.common.lgId));
    }
  };

  const openSelfSchedulingWindow = () => {
    if(infoPopup) {
      setSelfscheduleClick(true);
    } else {
    let w: number = 630;
    let h: number = 440; // default sizes
    if (window.screen) {
      w = window.screen.availWidth - 10;
      h = window.screen.availHeight - 70;
    }
    const selfSchedulingWindow: any = window.open(
      `${process.env.REACT_APP_TMS_URL}` + "/v2/course/" + sessionStorage.getItem("courseId") + "/booking",
      "Schedule Session",
      "height=" +
      h +
      ",width=" +
      w +
      ",dependent=yes,location=no,menubar=no," +
      "resizable=yes,scrollbars=yes,status=no,toolbar=no"
    );
    selfSchedulingWindow.focus();
    checkWindowCloseTimer(selfSchedulingWindow);
    }
  };

  const checkWindowCloseTimer = (learnshipPopUpWindow: any) => {
    const checkTimer: any = setInterval(() => {
      if (learnshipPopUpWindow.closed) {
        clearInterval(checkTimer);
        if(!allInfo.createSessionService.isLoading) {
          const courseId : number= Number(sessionStorage.getItem("courseId")) || 0;
          dispatch(allActions.createSessionServiceAction.createSessionService(courseId));
        }
        if(!allInfo.tmsLearnerSessions.isLoading && !allInfo.tmsLearnerSessions.isFailed) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId));
        }
      }
    }, 1000);
  };

  const [coursehit, setCoursehit]= useState(0);
  const [calendarhit, setcalendarHit]= useState(0);
  const [isCourseAvailable, setCourseAvailability] = useState(false);
  const [isUseravl, setIsUserAvailable] = useState(false);
  const [isScheduleRequired, SetScheduleRequiredFlag] = useState(false);
  const [loaderFlag, setLoaderFlag] = useState(true);
  const [error, setError] = useState(false);
  const [infoPopup, setInfoPopup] = useState(false);
  const [selfscheduleClick, setSelfscheduleClick] = useState(false);
  const [isCourseIdValid, setCourseIdValid] = useState(true);
  const [courseStatus, setCourseStatus] = useState(1);
  const location: any = useLocation(); 
  const [productId, setProductID] = useState(0);
  const [learnerCourse, setLearnerCourse] = useState({
    id: 0,
    name: "",
    length: "",
    statistics: {
      finishedSessions: 0,
      lostSessions: 0,
      upcomingSessions: 0,
      openSessions: 0,
    },
    hasTeacher: true,
  });
  let courseData: any = [{}];
  let patId: string;
  const handleClose = () => {
    setSelfscheduleClick(false);
  };
  const validateCourse = async () => {
    let courseData: any = [{}];
    const uuId: string = String(sessionStorage.getItem("luuId"));
    let courseId: any = parseInt(window.location.href.split("/")[4]);
    if(isNaN(courseId)) {
      setCourseIdValid(false);
      setLoaderFlag(false);
    } else {
      setCourseIdValid(true);
      if(((!allInfo.tmsCourses.isLoading && !allInfo.tmsCourses.isFailed && !allInfo.tmsCourses.data )) || (triggerDispatch && coursehit!==courseId && !allInfo.tmsCourses.isLoading)) {
        courseData = dispatch(allActions.tmsCoursesAction.getTMSCourses(uuId));
        setCoursehit(courseId);
      }
    }
  }

const checkUserAvailability = () => {
  if(validatedCourseId > 0) {
    const courseId : number = validatedCourseId;
    if(((typeof(allInfo.getTmsCalendarEvent)!=='undefined' && ! allInfo.getTmsCalendarEvent.data)|| (triggerDispatch)) && calendarhit!==courseId) {
      dispatch(allActions.getTMSCalendarEventAction.getTMSCalendarEvents(String(courseId)));
      setcalendarHit(courseId);
    }
  }
}

const getSummaryData = () => {
  const courseId : Number = validatedCourseId;
  if(allInfo.createSessionService.data) {
    setLearnerCourse(allInfo.createSessionService.data.createSessionService);
    setInfoPopup(!allInfo.createSessionService.data.createSessionService.hasTeacher);
    if(allInfo.createSessionService.data.createSessionService.statistics.openSessions > 0) {
      SetScheduleRequiredFlag(true);
    }
    setLoaderFlag(false);
  }
}
 useEffect(()=> {
  setLoaderFlag(true);
  if( typeof(sessionStorage.getItem("courseId")) !== 'undefined') {
    setTriggerDispatch(true);
    setLoaderFlag(true);
    setFeedbackHit(false);
    window.addEventListener("beforeunload", handleUnload);
    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }
 },[]);

 useEffect(()=> {
  if(typeof(allInfo.peopleInformation)!=='undefined' && allInfo.peopleInformation.data!==null && !allInfo.learnerJWToken.isLoading && !allInfo.learnerJWToken.data) {
    const resp = allInfo.peopleInformation.data.getpeopleInformation;
    getLearnerToken(resp.edgeUid,resp.username);
    setTriggerDispatch(true);
  }
  setIsTMSLoginComplete(true);    
 },[allInfo.peopleInformation]);

 const handleUnload = () => {
  sessionStorage.removeItem("courseId");
};
  useEffect(() => {
    // use effect to perform JWtoken and TMS calls
    let learnerToken = sessionStorage.getItem("JwToken");
    if(!allInfo.learnerJWToken.isLoading && allInfo.learnerJWToken.data) {
      learnerToken = allInfo.learnerJWToken.data.getLearnerJwtoken;
    }
    if (learnerToken === "" ||  (learnerToken === 'undefined' || learnerToken === null) && (sessionStorage.getItem(window.location.href.split("/")[4])!==sessionStorage.getItem("courseId"))) {
      setIsTMSLoginComplete(false);
      getLearnerInfo();
    }
    if(! allInfo.getLearnerFeedback.data  && allInfo.learnerJWToken.data && !feedbackHit) {
      sessionStorage.setItem("jwToken",allInfo.learnerJWToken.data.getLearnerJwtoken);
      dispatch(allActions.getLearnerFeedbackAction.getLearnerFeedback(allInfo.learnerJWToken.data.getLearnerJwtoken));
      if(allInfo.learnerJWToken.data.getLearnerJwtoken && allInfo.learnerJWToken.data.getLearnerJwtoken!=="")
      setFeedbackHit(true);
    }
  }, [allInfo.learnerJWToken,sessionStorage.getItem("JwToken"),triggerDispatch ]);

  useEffect(() => {
    // Once TMS calls and JWtoken is obtained. Validity of the course ID is checked
    if(isTMSloginComplete ||(typeof(allInfo.learnerToken)!=='undefined' && allInfo.learnerToken.data.getLearnerJwtoken) || typeof(sessionStorage.getItem("JwToken"))!=='undefined') {
      validateCourse();
    } else {
      getLearnerInfo();
    }
  }, [isTMSloginComplete, allInfo.learnerJWToken,  sessionStorage.getItem("JwToken"), triggerDispatch]);

  function getActiveProducts () {
    let activeLicenses:any = [];
    let sprintAndElevateProductIds = [18,20,26,27,28,29,25]
      if(allInfo.peopleInformation.data){
        allInfo.peopleInformation.data.getpeopleInformation.license.forEach((license:any) => {
          if(sprintAndElevateProductIds.includes(Number(license.productId)) && license.active === "1"){
            activeLicenses.push(Number(license.productId));
          }
        })
      }
      return activeLicenses;
  }

  useEffect(() => {
    if( allInfo.tmsCourses.data && allInfo.peopleInformation.data) {
      // Below logic is written to get the product ID of the active course
      let activeCourseData : any;
      let includeArr = JSON.parse(process.env.REACT_APP_BLENDED_PRODUCTS_FILTER || "").map((value: string) => value.toLowerCase()) || [{}];
      activeCourseData = getActiveCourse(allInfo.tmsCourses.data.getTMSGetCourse);
      // If language attribute is present then sprint other language learner
      if(activeCourseData["language"]) { 
        const foundObj = getActiveProducts();
        setProductID(foundObj ? foundObj[0] : "");
      } else {
        let filterIndex : any = includeArr.indexOf(activeCourseData.trainingType);
        setProductID(JSON.parse(process.env.REACT_APP_BLENDED_PRODUCT_ID || "")[filterIndex]);
      }
      const courseData = allInfo.tmsCourses.data != null ? allInfo.tmsCourses.data.getTMSGetCourse : null;
      // Once course ID is validated. Need to check if the course is active and availability is given for it.
      let courseId = parseInt(window.location.href.split("/")[4]);
      if (courseData != null && courseData.length > 0 ) {
        setCourseIdValid(courseData.find((data: any) => data.courseId === courseId) !== undefined);
        const filteredCourse = courseData.find((data: any) => data.courseId === courseId);
        filteredCourse &&  setCourseStatus(filteredCourse.status);
      }
    
      courseId = isNaN(courseId) ? 0 : courseId;
      if (courseData.find((data: any) => data.courseId === courseId) !== undefined && courseId > 0) {
        sessionStorage.setItem("courseId", String(courseId));
        setValidatedCourseId(courseId);
      } else {
        setstatus(sessionStorage.getItem("isScheduleRequired")!=="true"? 401 : 1);
        setLoaderFlag(false);
      }
      checkUserAvailability();      
    }
  }, [allInfo.tmsCourses,validatedCourseId, allInfo.peopleInformation.data]);

  useEffect(()=>{
    setLoaderFlag(true);
  },[triggerDispatch]);

  useEffect(() => { 
    if(allInfo.getTMSCalendarEvents?.data?.getTMSCalendarEvents) {
      const avlData = allInfo.getTMSCalendarEvents.data.getTMSCalendarEvents;
      if (avlData.records.length > 0) {
        patId = avlData.records[0].participants[0].id;
        if(!allInfo.getTMSLearnerAvailablity.data || triggerDispatch) {
          dispatch(allActions.getTMSLearnerAvailablityAction.getTMSLearnerAvailablity(patId));
        }
      } else {
        setLoaderFlag(false);
      }
    }
  }, [allInfo.getTMSCalendarEvents]);
  
  useEffect(() => {
    if(allInfo.getTMSLearnerAvailablity && allInfo.getTMSLearnerAvailablity.data) {      
      if(allInfo.getTMSLearnerAvailablity.data.getTMSLearnerAvailablity.records.length > 0 || productId === 29) {
        setIsUserAvailable(true);
        if((!allInfo.tmsLearnerSessions.data && !allInfo.tmsLearnerSessions.isLoading) || triggerDispatch) {
          dispatch(allActions.tmsLearnerSessionsAction.getStoreTMSLearnerSessionInfo(allInfo.common.luuId))
        }
      } else {
        setIsUserAvailable(false);
        setLoaderFlag(false);
      }
    }
  }, [allInfo.getTMSLearnerAvailablity]);

  useEffect(() => {
    if((allInfo.tmsLearnerSessions && allInfo.tmsLearnerSessions.data)) {
      if(allInfo.tmsLearnerSessions.data.getTMSLearnerSessions.length > 0) {
        let filterActiveCourseSessions = allInfo.tmsLearnerSessions.data.getTMSLearnerSessions.filter((sessions: any) => sessions.course === validatedCourseId);
        setCourseAvailability((filterActiveCourseSessions.length > 0 || sessionStorage.getItem("isDemoUser")) ? true : false);
        if( (!allInfo.createSessionService.data || triggerDispatch) && typeof(sessionStorage.getItem("courseId")) !== 'undefined') {
          dispatch(allActions.createSessionServiceAction.createSessionService(Number(sessionStorage.getItem("courseId"))));
          setCourseIdValid(true)
          setIsUserAvailable(true);
        }
      } else {
        setCourseAvailability(false);
        setLoaderFlag(false);
      }
    }
  }, [allInfo.tmsLearnerSessions]);

  useEffect(() => {
    getSummaryData();
  },[allInfo.createSessionService]);

  return ((isCourseIdValid && isCourseAvailable && isUseravl || productId === 29)) ? (
    <div className="ScheduleContainer">
      <div className="ScheduleTitle">
        <h2>{translate("myschedule_schedule")}</h2>
      </div>
      <div className="PageContainerBlock">
        <Loader showLoader={loaderFlag} />
        <div className="SessionSummary">
          <MyScheduleSummaryBlock
            Heading={String(learnerCourse.statistics.finishedSessions)}
            Description={translate("myschedule_statusCard_completed")}
            IsAddButtonRequired={false}
            HeaderTextColor="finished-sessions"
          ></MyScheduleSummaryBlock>
          <MyScheduleSummaryBlock
            Heading={String(learnerCourse.statistics.upcomingSessions + learnerCourse.statistics.openSessions)}
            Description={translate("myschedule_statusCard_remaining")}
            IsAddButtonRequired={false}
            HeaderTextColor="total-sessions"
          ></MyScheduleSummaryBlock>
          <MyScheduleSummaryBlock
            Heading={String(learnerCourse.statistics.openSessions)}
            Description={translate("myschedule_statusCard_scheduled")}
            IsAddButtonRequired={isScheduleRequired}
            ScheduleOnClick={openSelfSchedulingWindow}
            HeaderTextColor="open-sessions"
          ></MyScheduleSummaryBlock>

          <MyScheduleSummaryBlock
            Heading={String(learnerCourse.statistics.lostSessions)}
            Description={translate("myschedule_statusCard_lost")}
            IsAddButtonRequired={false}
            HeaderTextColor="lost-sessions"
          ></MyScheduleSummaryBlock>
          { selfscheduleClick  &&
            <Dialog
      open={infoPopup}
      onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className=""
    >
      <DialogTitle>
       <Typography className="teacher-info-title">{translate("myschedule_no_teacher_title")} </Typography> 
        <CloseIcon className="closeButton" onClick={handleClose}></CloseIcon>
      </DialogTitle> 
      <DialogContent className="teacher-info-body">
      {translate("myschedule_no_teacher_body")}
        </DialogContent>
        </Dialog>
    }
        </div>
        <PastAndUpcomingSessions prodId={ productId } />
        <Loader showLoader={loaderFlag} />
        <Toaster
          open={toastOptions.toastOpen}
          severity={toastOptions.toastSeverity}
          toasterClosed={toasterHandle}
          messageKey={toastOptions.toastMessageKey}
        />
      </div>
    </div>
  ) : (
    <React.Fragment>
      <Loader showLoader={loaderFlag} />
      <Toaster
        open={toastOptions.toastOpen}
        severity={toastOptions.toastSeverity}
        toasterClosed={toasterHandle}
        messageKey={toastOptions.toastMessageKey}
      />
      <NoTrainerScenarioBlock
        isUseravl={isUseravl}
        isCourseAvailable={isCourseAvailable}
        setLoaderFlag={setLoaderFlag}
        status={status}
        isCourseIdValid={isCourseIdValid}
        courseStatus = {courseStatus}
        productId = {productId?productId : (location?.state?.productId)}
      ></NoTrainerScenarioBlock>
    </React.Fragment>
  );
};
export default ProductSessionsBlock;
